module.exports = "./img/4de874d444366e7e6cea9dbd0ea4d4d7.jpg";